(function() {
    'use strict';

    angular.module('product')
        .controller('CategoryCreateController', CategoryCreateController);

    CategoryCreateController.$inject = ['$state', 'categoryDataSrvc', 'notificationSrvc', 'categoryMessagesConst', 'productCountryConst', 'errorNotificationSrvc'];

    function CategoryCreateController($state, categoryDataSrvc, notificationSrvc, categoryMessagesConst, productCountryConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            title_pl: [],
            title_en: [],
            title_de: [],
            title_cpde: [],
            title_cpen: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            title_seo_pl: [],
            title_seo_de: [],
            title_seo_en: [],
            title_seo_cpde: [],
            title_seo_cpen: [],
            description_seo_pl: [],
            description_seo_de: [],
            description_seo_en: [],
            description_seo_cpde: [],
            description_seo_cpen: [],
            keywords_seo_pl: [],
            keywords_seo_de: [],
            keywords_seo_en: [],
            keywords_seo_cpde: [],
            keywords_seo_cpen: [],
            is_published: [],
            parent: [],
            image: [],
            available_in_countries: [],
            nonFieldErrors: []
        };
        self.categoryData = {
            title_pl: '',
            title_en: '',
            title_de: '',
            title_cpde: '',
            title_cpen: '',
            description_pl: '',
            description_en: '',
            description_de: '',
            description_cpde: '',
            description_cpen: '',
            title_seo_pl: '',
            title_seo_de: '',
            title_seo_en: '',
            title_seo_cpde: '',
            title_seo_cpen: '',
            description_seo_pl: null,
            description_seo_de: null,
            description_seo_en: null,
            description_seo_cpde: null,
            description_seo_cpen: null,
            keywords_seo_pl: null,
            keywords_seo_de: null,
            keywords_seo_en: null,
            keywords_seo_cpde: null,
            keywords_seo_cpen: null,
            is_published: true,
            parent: null,
            image: null,
            available_in_countries: []
        };
        self.categories = [];
        self.countryList = productCountryConst;

        self.createCategory = createCategory;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getPotentialParents();
        }

        function getPotentialParents() {
            return categoryDataSrvc.categoryParents()
                .$promise.then(function(response) {
                    self.categories = response;
                    return response;
                });
        }

        function createCategory() {
            categoryDataSrvc.create(
                self.categoryData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", categoryMessagesConst.add);
                    $state.go('layout.category.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
